(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-bar"]) return;
  try {
    
        (function () {
            function initNewsletter() {
                document.querySelectorAll('[data-elite-newsletter]').forEach(function (section) {
                    if (section.dataset.newsletterBound) return;
                    section.dataset.newsletterBound = 'true';
                    var form = section.querySelector('form');
                    var fields = section.querySelector('[data-newsletter-fields]');
                    var coupon = section.querySelector('[data-newsletter-coupon]');
                    var pendingKey = 'elite10-footer-pending';
                    var confirmedKey = 'elite10-footer-confirmed';
                    if (!form || !fields) return;
                    if (coupon) {
                        var confirmed = false;
                        try {
                            var pendingAt = Number(sessionStorage.getItem(pendingKey));
                            confirmed = sessionStorage.getItem(confirmedKey) === 'true' ||
                                (pendingAt > 0 && Date.now() - pendingAt < 600000);
                            sessionStorage.removeItem(pendingKey);
                            if (confirmed) sessionStorage.setItem(confirmedKey, 'true');
                        } catch (error) {}
                        coupon.hidden = !confirmed;
                        fields.hidden = confirmed;
                    }
                    form.addEventListener('submit', function () {
                        if (!form.checkValidity()) return;
                        try {
                            sessionStorage.removeItem(confirmedKey);
                            sessionStorage.setItem(pendingKey, String(Date.now()));
                        } catch (error) {}
                    });
                    var copyButton = section.querySelector('[data-copy-newsletter-code]');
                    if (copyButton) {
                        copyButton.addEventListener('click', async function () {
                            if (!coupon || coupon.hidden) return;
                            var code = section.querySelector('[data-newsletter-code]');
                            var feedback = section.querySelector('[data-copy-feedback]');
                            try {
                                await navigator.clipboard.writeText(code.textContent.trim());
                                copyButton.textContent = copyButton.dataset.copiedLabel;
                                feedback.textContent = copyButton.dataset.copiedLabel;
                            } catch (error) {
                                var range = document.createRange();
                                range.selectNodeContents(code);
                                var selection = window.getSelection();
                                selection.removeAllRanges();
                                selection.addRange(range);
                                feedback.textContent = copyButton.dataset.manualLabel;
                            }
                        });
                    }
                });
            }
            initNewsletter();
            document.addEventListener('shopify:section:load', initNewsletter);
        })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phantom-product"] && !Shopify.designMode) return;
  try {
    

function blackHawkCreateOfferTiming({ root, dialog, attempt }) {
const state = { priceShown: false, finalShown: false, priceReady: false, finalReady: false, nextTimed: 0, elapsed: 0 };
const delays = [50000, 150000];
const priceAnchor = root.querySelector('.ph-pack');
const finalAnchor = root.querySelector('.bh-photo-cta [data-buy]');
let visibleSince = document.hidden ? null : Date.now();
let pending = false, destroyed = false, cartTimer = null, cartVisibleBefore = false, cartSuppressed = false, confirmedUntil = 0;
const cartVisible = () => Boolean(document.querySelector('.mini-cart[aria-hidden="false"]'));
const cartReady = () => !cartSuppressed && (cartVisible() || Date.now() < confirmedUntil);
const consumeTimed = () => { while (state.nextTimed < delays.length && state.elapsed >= delays[state.nextTimed]) state.nextTimed++; };
const accountTime = () => {
const now = Date.now();
if (visibleSince !== null) state.elapsed += Math.max(0, now - visibleSince);
visibleSince = document.hidden ? null : now;
};
const suppressCart = () => {
cartSuppressed = true; confirmedUntil = 0;
if (cartTimer !== null) { clearTimeout(cartTimer); cartTimer = null; }
};
const run = async (reason) => {
if (pending || destroyed || document.hidden || dialog.open || window.EliteSitewide25?.isActive()) return 'blocked';
if ((reason === 'price' && state.priceShown) || (reason === 'final' && state.finalShown)) return 'blocked';
pending = true;
try {
const result = await attempt(reason);
if (result === 'opened') {
if (reason === 'price') { state.priceShown = true; state.priceReady = false; }
else if (reason === 'final') { state.finalShown = true; state.finalReady = false; }
else if (reason === 'time') consumeTimed();
if (reason === 'cart') suppressCart();
} else if (reason === 'price' && result === 'ineligible') state.priceReady = false;
else if (reason === 'final' && result === 'ineligible') state.finalReady = false;
else if (reason === 'time' && result === 'ineligible') consumeTimed();
else if (reason === 'cart' && result === 'ineligible') suppressCart();
return result;
} finally { pending = false; }
};
const scheduleCart = () => {
const visible = cartVisible();
if (!visible && Date.now() >= confirmedUntil) {
if (cartTimer !== null) { clearTimeout(cartTimer); cartTimer = null; }
cartSuppressed = false;
}
if (visible && !cartVisibleBefore) cartSuppressed = false;
cartVisibleBefore = visible;
if (cartReady() && cartTimer === null && !dialog.open && !destroyed) {
cartTimer = setTimeout(() => { cartTimer = null; if (cartReady()) run('cart'); }, 5000);
}
};
const confirmAdd = () => {
confirmedUntil = Date.now() + 15000; cartSuppressed = false;
if (cartTimer !== null) { clearTimeout(cartTimer); cartTimer = null; }
scheduleCart();
};
const scan = () => {
if (destroyed || document.hidden || dialog.open || cartVisible()) return;
const passed = (element) => { const bounds = element?.getBoundingClientRect(); return bounds && bounds.height > 0 && bounds.bottom <= 0; };

if (!state.finalShown && passed(finalAnchor)) state.finalReady = true;
checkReady();
};
const checkReady = () => {

if (state.finalReady && !state.finalShown) { run('final'); return true; }
return false;
};
const tick = () => {
if (root.isConnected === false) { destroy(); return; }
accountTime(); scheduleCart();
if (document.hidden) return;
if (dialog.open) { consumeTimed(); return; }
if (!cartVisible() && !checkReady() && state.nextTimed < delays.length && state.elapsed >= delays[state.nextTimed]) run('time');
};
const visibility = () => { accountTime(); if (!document.hidden) { scheduleCart(); scan(); } };
const observer = typeof MutationObserver === 'function' ? new MutationObserver(scheduleCart) : null;
observer?.observe(document.documentElement, { attributes: true, attributeFilter: ['aria-hidden'], childList: true, subtree: true });
window.addEventListener('scroll', scan, { passive: true });
document.addEventListener('visibilitychange', visibility);
const timer = setInterval(tick, 1000);
function destroy() {
if (destroyed) return;
destroyed = true; clearInterval(timer); suppressCart(); observer?.disconnect();
window.removeEventListener('scroll', scan); document.removeEventListener('visibilitychange', visibility);
}
scheduleCart();
return { state, scan, tick, confirmAdd, suppressCart, cartReady, destroy };
}
function blackHawkOpenCart(root, variant) {
const target = document.documentElement;
const detail = { quantity: 0, variant: { id: variant?.id, product_id: Number(root.dataset.productId) } };
target.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
target.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail }));
}
function blackHawkStock(root, variant) {
const notice = root.querySelector('[data-stock-status]');
if (!notice) return;
const dispatch = root.querySelector('[data-dispatch-cue]');
if (dispatch) dispatch.hidden = !variant?.available;
if (!variant) { notice.hidden = true; return; }
const language = blackHawkLanguage(root);
notice.dataset.low = String(Boolean(variant.available));
notice.hidden = false;
const label = notice.querySelector('[data-stock-text]') || notice;
label.textContent = variant.available ? language === 'pt' ? 'Poucas peças em estoque' : 'Quedan pocas unidades' : language === 'pt' ? 'Esta opção está esgotada.' : 'Esta opción está agotada.';
}

function phantomHumanColor(value) {
const clean = String(value).replace(/^\s*(?:IX7|IX9|X9)\s*(?:[—-]\s*)?/i, '').replace(/^CP\s*/i, '').replace(/\(?\s*spring.*$/i, '').replace(/[()]+$/g, '').trim();
const labels = { khaki: 'Caqui', black: 'Negro', gray: 'Gris', grey: 'Gris', 'army green': 'Verde militar', 'wolf brown': 'Marrón', 'black python': 'Black Python', 'night camouflage': 'Camuflaje nocturno', 'night camo': 'Camuflaje nocturno', jungle: 'Camuflaje selva', 'jungle camo': 'Camuflaje selva', 'jungle camouflage': 'Camuflaje selva' };
return labels[clean.toLowerCase()] || clean;
}
function phantomEnhanceDescription(root) {
const description = root.querySelector('.ph-description');
const contract = root.querySelector('[data-phantom-description-media]');
if (!description || !contract) return;
const headings = Array.from(description.querySelectorAll('h2,h3'));
const entries = JSON.parse(contract.textContent || '[]');
entries.forEach((entry) => {
const heading = headings.find((node) => node.textContent.trim() === entry.heading);
const native = root.querySelector(`[data-media-id="${String(entry.media_id)}"] img`);
if (!heading || !native || description.querySelector(`[data-phantom-inline-photo="${String(entry.media_id)}"]`)) return;
let paragraph = heading.nextElementSibling;
let lastParagraph = null;
while (paragraph && !/^H[23]$/.test(paragraph.tagName)) {
if (paragraph.tagName === 'P') lastParagraph = paragraph;
paragraph = paragraph.nextElementSibling;
}
if (!lastParagraph) return;
const figure = document.createElement('figure');
figure.className = 'ph-inline-photo';
figure.dataset.phantomInlinePhoto = String(entry.media_id);
const image = native.cloneNode(true);
image.alt = entry.alt;
image.loading = 'lazy';
image.removeAttribute('fetchpriority');
figure.append(image);
if (entry.caption) {
const caption = document.createElement('figcaption');
caption.textContent = entry.caption;
figure.append(caption);
}
lastParagraph.after(figure);
});
}
function phantomAllowedVariants(productId, variants) {
const pantsId = String(productId);
if (['15447369810141', '15447369973981'].includes(pantsId)) {
return variants.filter((variant) => {
const color = String(variant.options?.[0] || '');
return !/black\s*python/i.test(color) && (pantsId !== '15447369973981' || /^(?:IX9|X9)\s*[—-]/i.test(color));
});
}
if (String(productId) !== '15447369875677') return variants;
const completeKitIds = ['68274502271197', '68274502303965', '68274502336733'];
return variants.filter((variant) => completeKitIds.includes(String(variant.id)));
}
function phantomSelectLabels(select, productId) {
if (!select?.options) return;
const kitColors = { '68274502271197': 'Kit completo — Negro', '68274502303965': 'Kit completo — Caqui', '68274502336733': 'Kit completo — Verde militar' };
Array.from(select.options).forEach((option) => {
if (String(productId) === '15447369875677') {
if (!kitColors[option.value]) option.remove();
else option.textContent = kitColors[option.value];
} else if (String(productId) === '15447369973981') {
if (/black\s*python|^IX7\s*[—-]/i.test(option.textContent)) option.remove();
} else if (String(productId) === '15447369941213') option.textContent = option.textContent.split('/')[0].trim();
});
if (!select.selectedOptions.length && select.options.length) select.value = select.options[0].value;
}
function phantomHumanSize(value, compactAsian = false) {
const clean = String(value).split('(')[0].trim().replace(/XXXL/g, '3XL').replace(/XXL/g, '2XL');
return compactAsian ? clean.replace(/^Asian\s+/i, '') : clean;
}
function blackHawkLanguage(root) {
return String(document.documentElement?.lang || root?.dataset?.language || 'en').toLowerCase().startsWith('pt') ? 'pt' : 'en';
}
function blackHawkSizeAlias(value, productId, language = 'en') {
const clean = phantomHumanSize(value);
const token = clean.toLowerCase().replace(/[–−]/g, '-').replace(/\s+/g, '');
const english = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
const portuguese = ['P', 'M', 'G', 'GG', '2GG', '3GG', '4GG', '5GG'];
let position = -1;
if (['15447369810141', '15447369973981'].includes(String(productId))) {
position = ['30-32in', '32-34in', '34-36in', '36-38in', '38-40in', '40-41in'].indexOf(token);
if (position < 0) position = english.slice(0, 6).indexOf(clean.toUpperCase());
return position >= 0 ? ['30–32', '32–34', '34–36', '36–38', '38–40', '40–41'][position] : clean;
} else if (String(productId) === '15447369908445') {
const chest = token.match(/^(\d+(?:\.\d+)?)in(?:chest)?$/);
if (chest) position = [42.5, 44.1, 45.7, 47.2, 48.8, 50.4, 52, 53.5].indexOf(Number(chest[1]));
else if (/^Asian\s+/i.test(clean)) position = ['M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'].indexOf(clean.replace(/^Asian\s+/i, '').toUpperCase());
else position = english.indexOf(clean.toUpperCase());
}
return position >= 0 ? (language === 'pt' ? portuguese : english)[position] : clean;
}
function blackHawkLocalize(root, productId, language = blackHawkLanguage(root)) {
root.querySelectorAll('[data-bh-en][data-bh-pt]').forEach((node) => { node.textContent = language === 'pt' ? node.dataset.bhPt : node.dataset.bhEn; });
root.querySelectorAll('[data-bh-size-value]').forEach((node) => { node.textContent = blackHawkSizeAlias(node.dataset.bhSizeValue, productId, language); });
}
function blackHawkChoiceAxes(variants) {
if (variants[0]?.options?.length !== 2) return null;
const sizeIndex = [0, 1].find((index) => variants.every((variant) => /^(?:(?:Asian\s+)?(?:S|M|L|XL|XXL|XXXL|[2-6]XL)|P|G|GG|[2-5]GG|\d+(?:\.\d+)?(?:[–-]\d+(?:\.\d+)?)? in(?: chest)?)$/i.test(String(variant.options[index]).trim())));
return sizeIndex === undefined ? null : { sizeIndex, colorIndex: 1 - sizeIndex };
}
function blackHawkCreateCompactChoices({ host, variants, getOptions, setOptions, isBusy, productId, language = 'en', preview = true, onSizeGuide, sizeGuideId }) {
const axes = blackHawkChoiceAxes(variants);
if (!host || !axes) return null;
const { colorIndex, sizeIndex } = axes;
const make = (tag, className, text) => {
const node = document.createElement(tag);
if (className) node.className = className;
if (text !== undefined) node.textContent = text;
return node;
};
host.className = `${host.className || ''} bh-compact-choices`.trim();
const photo = make('div', 'bh-pair-preview');
const image = make('img');
image.width = 160; image.height = 160; image.loading = 'lazy';
if (preview) { photo.append(image); host.append(photo); }
const fields = make('div', 'bh-compact-fields');
const controls = [colorIndex, sizeIndex].map((index) => {
const color = index === colorIndex;
const field = make('div', 'bh-compact-field');
const heading = make('div', color ? 'bh-color-heading' : 'ph-size-heading');
const label = make('label', 'ph-choice-heading', color ? language === 'pt' ? 'Cor' : 'Color' : language === 'pt' ? 'Tamanho' : 'Talla');
const select = make('select');
select.id = `${host.id}-${color ? 'color' : 'size'}-choice`;
label.htmlFor = select.id;
heading.append(label);
const values = [...new Set(variants.map((variant) => String(variant.options[index])))];
const options = values.map((value) => {
const option = make('option'); option.value = value;
const text = color ? phantomHumanColor(value) : blackHawkSizeAlias(value, productId, language);
option.textContent = text;
if (color) {
const duplicates = values.filter((candidate) => phantomHumanColor(candidate) === text);
if (duplicates.length > 1) option.setAttribute('aria-label', `${text}, ${language === 'pt' ? 'opção' : 'option'} ${duplicates.indexOf(value) + 1}`);
}
select.append(option);
return { value, option };
});
field.append(heading, select);
select.addEventListener('change', () => {
const next = [...getOptions()]; next[index] = select.value; setOptions(next);
});
fields.append(field);
return { index, color, select, options };
});
host.append(fields);
if (onSizeGuide) {
const guide = make('button', 'ph-size-guide-trigger', language === 'pt' ? 'Guia de tamanho' : 'Guía de medidas');
guide.type = 'button'; guide.setAttribute('aria-expanded', 'false');
if (sizeGuideId) guide.setAttribute('aria-controls', sizeGuideId);
guide.addEventListener('click', onSizeGuide);
const guideRow = make('div', 'bh-compact-guide'); guideRow.append(guide); host.append(guideRow);
}
const refresh = () => {
const selected = getOptions().map(String);
controls.forEach(({ index, color, select, options }) => {
select.value = selected[index] || '';
select.disabled = Boolean(isBusy());
options.forEach(({ value, option }) => {
const matches = color ? variants.filter((variant) => String(variant.options[colorIndex]) === value) : variants.filter((variant) => String(variant.options[colorIndex]) === selected[colorIndex] && String(variant.options[sizeIndex]) === value);
option.disabled = !matches.some((variant) => variant.available);
});
});
if (preview) {
const exact = variants.find((variant) => variant.options.every((value, index) => String(value) === selected[index]));
const sameColor = variants.find((variant) => String(variant.options[colorIndex]) === selected[colorIndex] && variant.featured_image?.src);
const source = exact?.featured_image?.src || sameColor?.featured_image?.src;
photo.hidden = !source;
if (source) { image.src = source; image.alt = `${phantomHumanColor(selected[colorIndex] || '')} — ${language === 'pt' ? 'cor selecionada' : 'color seleccionado'}`; }
}
};
refresh();
return { refresh };
}
function phantomCreateClothingPicker({ host, variants, getOptions, setOptions, isBusy, compactAsian = false, onSizeGuide, sizeGuideId, productId, language = 'en' }) {
if (!host || variants[0]?.options?.length !== 2) return null;
const sizeIndex = [0, 1].find((index) => variants.every((variant) => /^(?:(?:Asian\s+)?(?:S|M|L|XL|XXL|XXXL|[2-6]XL)(?:\s*\(.*\))?|\d+(?:\.\d+)?(?:[–-]\d+(?:\.\d+)?)? in(?: chest)?)$/i.test(String(variant.options[index]).trim())));
if (sizeIndex === undefined) return null;
const colorIndex = 1 - sizeIndex;
const colors = [...new Set(variants.map((variant) => String(variant.options[colorIndex])))];
const sizes = [...new Set(variants.map((variant) => String(variant.options[sizeIndex])))];
const make = (tag, className, text) => {
const node = document.createElement(tag);
if (className) node.className = className;
if (text !== undefined) node.textContent = text;
return node;
};
const heading = make('p', 'ph-choice-heading');
heading.id = `${host.id}-color`;
const colorGrid = make('div', 'ph-color-choices');
colorGrid.setAttribute('role', 'group');
colorGrid.setAttribute('aria-labelledby', heading.id);
colorGrid.style.setProperty('--ph-color-columns', String(Math.min(colors.length, 8)));
colorGrid.style.setProperty('--ph-color-mobile-columns', String(Math.min(colors.length, 6)));
colorGrid.style.setProperty('--ph-color-max-width', `${Math.min(colors.length, 8) * 64 + (Math.min(colors.length, 8) - 1) * 8}px`);
const colorButtons = colors.map((value) => {
const button = make('button', 'ph-color-choice');
button.type = 'button';
const label = phantomHumanColor(value);
const duplicates = colors.filter((color) => phantomHumanColor(color) === label);
const accessibleLabel = duplicates.length > 1 ? `${label}, option ${duplicates.indexOf(value) + 1}` : label;
button.setAttribute('aria-label', accessibleLabel);
button.title = accessibleLabel;
const image = make('img');
image.alt = '';
image.loading = 'lazy';
image.width = 128;
image.height = 128;
button.append(image);
button.addEventListener('click', () => {
if (button.disabled) return;
const next = [...getOptions()];
next[colorIndex] = value;
setOptions(next);
});
colorGrid.append(button);
return { value, button, image };
});
const sizeHeading = make('p', 'ph-choice-heading');
sizeHeading.id = `${host.id}-size`;
let sizeHeadingContent = sizeHeading;
if (onSizeGuide) {
sizeHeadingContent = make('div', 'ph-size-heading');
const guideButton = make('button', 'ph-size-guide-trigger', language === 'pt' ? 'Guia de tamanho' : 'Guía de medidas');
guideButton.type = 'button';
guideButton.setAttribute('data-size-guide-open', '');
guideButton.setAttribute('aria-expanded', 'false');
guideButton.setAttribute('aria-controls', sizeGuideId);
guideButton.addEventListener('click', onSizeGuide);
sizeHeadingContent.append(sizeHeading, guideButton);
}
const sizeGrid = make('div', 'ph-size-choices');
sizeGrid.setAttribute('role', 'group');
sizeGrid.setAttribute('aria-labelledby', sizeHeading.id);
const sizeButtons = sizes.map((value) => {
const button = make('button', 'ph-size-choice', productId ? blackHawkSizeAlias(value, productId, language) : phantomHumanSize(value, compactAsian));
button.type = 'button';
button.setAttribute('aria-label', productId ? `${blackHawkSizeAlias(value, productId, language)} — ${phantomHumanSize(value)}` : phantomHumanSize(value));
button.addEventListener('click', () => {
if (button.disabled) return;
const next = [...getOptions()];
next[sizeIndex] = value;
setOptions(next);
});
sizeGrid.append(button);
return { value, button };
});
host.append(heading, colorGrid, sizeHeadingContent, sizeGrid);
const refresh = () => {
const selected = getOptions();
heading.textContent = `${language === 'pt' ? 'Cor' : 'Color'}: ${phantomHumanColor(selected[colorIndex] || '')}`;
sizeHeading.textContent = `${['15447369810141', '15447369973981'].includes(String(productId)) ? (language === 'pt' ? 'Cintura (pol.)' : 'Cintura (pulg.)') : (language === 'pt' ? 'Tamanho' : 'Talla')}: ${productId ? blackHawkSizeAlias(selected[sizeIndex] || '', productId, language) : phantomHumanSize(selected[sizeIndex] || '', compactAsian)}`;
colorButtons.forEach(({ value, button, image }) => {
const matches = variants.filter((variant) => String(variant.options[colorIndex]) === value);
const nativeImage = matches.find((variant) => String(variant.options[sizeIndex]) === String(selected[sizeIndex]) && variant.featured_image?.src)?.featured_image || matches.find((variant) => variant.featured_image?.src)?.featured_image;
if (nativeImage?.src) { image.src = nativeImage.src; image.hidden = false; }
else image.hidden = true;
button.setAttribute('aria-pressed', String(String(selected[colorIndex]) === value));
button.disabled = Boolean(isBusy() || !matches.some((variant) => variant.available));
});
sizeButtons.forEach(({ value, button }) => {
const exact = variants.find((variant) => String(variant.options[colorIndex]) === String(selected[colorIndex]) && String(variant.options[sizeIndex]) === value);
button.setAttribute('aria-pressed', String(String(selected[sizeIndex]) === value));
button.disabled = Boolean(isBusy() || !exact?.available);
});
};
refresh();
return { refresh };
}
(() => {
const initialize = (root) => {
if (root.dataset.ready) return;
const variants = phantomAllowedVariants(root.dataset.productId, JSON.parse(root.dataset.variants || '[]'));
const form = root.querySelector('.ph-form');
if (!form || !variants.length) return;

if (root.dataset.productId === '15447369810141') {
const summary = root.querySelector('.ph-summary');
const updateStickyTop = () => summary.style.setProperty('--bh-sticky-top', `${Math.min(80, window.innerHeight - summary.offsetHeight - 16)}px`);
if (window.ResizeObserver) new ResizeObserver(updateStickyTop).observe(summary);
window.addEventListener('resize', updateStickyTop, { passive: true });
updateStickyTop();
const sticky = root.querySelector('[data-bh-sticky-buy]');
const mainBuy = form.querySelector('[data-buy]');
if (sticky && mainBuy) {
const updateStickyVisibility = () => { sticky.hidden = mainBuy.getBoundingClientRect().bottom > 0; };
window.addEventListener('scroll', updateStickyVisibility, { passive: true });
window.addEventListener('resize', updateStickyVisibility, { passive: true });
if (window.IntersectionObserver) new IntersectionObserver(updateStickyVisibility, { threshold: 0 }).observe(mainBuy);
updateStickyVisibility();
root.querySelector('[data-bh-return-buy]').addEventListener('click', () => {
root.querySelector('.ph-pack').scrollIntoView({ behavior: 'smooth', block: 'start' });
});
}

}
const buttons = Array.from(root.querySelectorAll('[data-buy]'));
const packInputs = Array.from(root.querySelectorAll('input[name="phantom_pack"]'));
const twoPairOfferReady = root.dataset.twoPairOfferReady === 'true';
const pieces = Array.from(root.querySelectorAll('[data-piece]'));
const clothingPickers = [];
const status = root.querySelector('[data-cart-status]');
const reviewLink = root.querySelector('[data-review-link]');
const nativeId = root.querySelector('[data-native-id]');
const sizeGuideTemplate = root.querySelector('[data-size-guide-template]');
const openSizeGuide = (event) => {
if (!sizeGuideTemplate) return;
const button = event.currentTarget;
const host = button.closest('[data-clothing-controls]') || root.querySelector('[data-clothing-controls]');
if (!host) return;
let panel = host.querySelector('.bh-inline-guide');
if (!panel) {
panel = document.createElement('div');
panel.className = 'bh-inline-guide';
panel.id = `${host.id}-inline-guide`;
panel.hidden = true;
panel.append(sizeGuideTemplate.content.cloneNode(true));
(host.querySelector('.bh-compact-guide') || host.querySelector('.ph-size-heading')).after(panel);
blackHawkLocalize(panel, root.dataset.productId, blackHawkLanguage(root));
}
panel.hidden = !panel.hidden;
button.setAttribute('aria-controls', panel.id);
button.setAttribute('aria-expanded', String(!panel.hidden));
};
root.querySelector('[data-size-guide-fallback] button')?.addEventListener('click', openSizeGuide);
blackHawkLocalize(root, root.dataset.productId, blackHawkLanguage(root));
phantomEnhanceDescription(root);
const extras = Array.from(root.querySelectorAll('[data-extra-choice]')).map((node) => ({
node,
variants: phantomAllowedVariants(node.dataset.choiceProductId, JSON.parse(node.dataset.choiceVariants || '[]')),
checkbox: node.querySelector('[data-choice-check]'),
select: node.querySelector('[data-choice-select]'),
toggle: node.querySelector('[data-choice-toggle]'),
kind: node.dataset.choiceKind,
}));
extras.forEach((extra) => phantomSelectLabels(extra.select, extra.node.dataset.choiceProductId));
const currency = root.dataset.currency || 'USD';
const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
const routeRoot = (root.dataset.root || '/').replace(/\/?$/, '/');
let isBusy = false;
let alreadyAdded = false;
const requestedId = String(root.dataset.selectedId);
const initial = variants.find((v) => String(v.id) === requestedId) || variants.find((v) => v.available) || variants[0];
const findVariant = (piece) => {
const options = Array.from(piece.querySelectorAll('[data-option-index]')).map((select) => select.value);
return variants.find((variant) => variant.options.every((value, index) => String(value) === options[index]));
};
const selectedPack = () => Number(packInputs.find((input) => input.checked)?.value || 1);
const getPack = () => twoPairOfferReady && (specialPair || selectedPack() === 2) ? 2 : 1;
const extraVariant = (extra) => extra.variants.find((variant) => String(variant.id) === extra.select.value);
const selectedExtras = () => extras.filter((extra) => extra.checkbox.checked).map((extra) => ({ ...extra, variant: extraVariant(extra) }));
const showMedia = (id) => {
const media = Array.from(root.querySelectorAll('[data-media-id]'));
if (!media.some((item) => item.dataset.mediaId === String(id))) return;
media.forEach((item) => {
item.hidden = item.dataset.mediaId !== String(id);
if (item.hidden) item.querySelectorAll('video').forEach((video) => video.pause());
});
root.querySelectorAll('[data-media-target]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id))));
};
const imagePath = (src) => {
try { return new URL(src, location.origin).pathname; } catch { return ''; }
};
const showVariantImage = (variant, updatePack = true) => {
const colorIndex = blackHawkChoiceAxes(variants)?.colorIndex;
const sameColor = colorIndex === undefined ? null : variants.find((candidate) => candidate.options[colorIndex] === variant?.options?.[colorIndex] && candidate.featured_image?.src);
const src = variant?.featured_image?.src || sameColor?.featured_image?.src;
if (!src) return;
const target = Array.from(root.querySelectorAll('[data-media-id]')).find((media) => imagePath(media.dataset.imageUrl) === imagePath(src));
if (target) showMedia(target.dataset.mediaId);
const packImage = root.querySelector('[data-pack-one-image]');
if (packImage && updatePack) { packImage.src = src; packImage.removeAttribute('srcset'); }
};
const returnToVariantImage = () => {
const stage = root.querySelector('.ph-media-stage');
if (!stage) return;
let header = document.querySelector('.header');
let headerOffset = 0;
while (header && header !== document.body) {
if (['fixed', 'sticky'].includes(getComputedStyle(header).position)) {
headerOffset = Math.max(0, header.getBoundingClientRect().height);
break;
}
header = header.parentElement;
}
const top = Math.max(0, stage.getBoundingClientRect().top + window.scrollY - headerOffset - 12);
window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
};
const setText = (selector, value) => root.querySelectorAll(selector).forEach((node) => { node.textContent = value; });
const openCart = () => blackHawkOpenCart(root, findVariant(pieces[0]));
const update = (changedPiece) => {
const pack = getPack();
const first = findVariant(pieces[0]);
const second = findVariant(pieces[1]);
blackHawkStock(root, !first?.available ? first : pack === 2 ? second : first);
pieces[1].hidden = pack !== 2;
pieces.forEach((piece) => {
const match = findVariant(piece);
piece.querySelector('[data-piece-availability]').textContent = !match ? 'Esta combinación no está disponible.' : match.available ? '' : 'Esta combinación está agotada.';
});
const firstPrice = first?.price ?? initial.price;
const secondPrice = second?.price ?? firstPrice;
const pairTotal = firstPrice + Math.round(secondPrice * 0.6);
const regularTotal = firstPrice + secondPrice;
const selected = selectedExtras();
const gearTotal = selected.filter((extra) => extra.kind === 'addon').reduce((sum, extra) => sum + (extra.variant?.price || 0), 0);
const total = (pack === 2 ? specialPair ? firstPrice + Math.round(secondPrice * 0.5) : pairTotal : firstPrice) + gearTotal;
if (offerNotice) offerNotice.hidden = !specialPair;
const available = Boolean(first?.available && (pack === 1 || second?.available) && selected.every((extra) => extra.variant?.available));
packInputs.forEach((input) => { input.disabled = isBusy || (!twoPairOfferReady && input.value === '2'); });
pieces.forEach((piece) => piece.querySelectorAll('[data-option-index]').forEach((select) => { select.disabled = isBusy; }));
extras.forEach((extra) => {
const variant = extraVariant(extra);
const availableOption = Boolean(variant?.available);
extra.checkbox.disabled = isBusy || !availableOption;
extra.select.disabled = isBusy;
if (extra.toggle) {
extra.toggle.disabled = isBusy || (!availableOption && !extra.checkbox.checked);
extra.toggle.textContent = extra.checkbox.checked ? 'Añadido' : '+ Añadir';
extra.toggle.setAttribute('aria-pressed', String(extra.checkbox.checked));
extra.toggle.setAttribute('aria-label', `${extra.checkbox.checked ? 'Remove' : 'Add'} ${extra.node.dataset.choiceTitle} ${extra.checkbox.checked ? 'from' : 'to'} my order`);
}
extra.node.querySelector('[data-choice-price]').textContent = money(variant?.price || 0);
extra.node.querySelector('[data-choice-availability]').textContent = availableOption ? '' : 'Esta combinación está agotada.';
const extraCompare = extra.node.querySelector('[data-choice-compare]');
if (extraCompare) {
extraCompare.hidden = !(variant?.compare_at_price > variant?.price);
extraCompare.textContent = variant?.compare_at_price ? money(variant.compare_at_price) : '';
}
const image = extra.node.querySelector('[data-choice-image]');
if (image && variant?.featured_image?.src) { image.src = variant.featured_image.src; image.removeAttribute('srcset'); }
extra.picker?.refresh();
});
const gearNote = root.querySelector('[data-extra-total]');
if (gearNote) { gearNote.hidden = gearTotal === 0; gearNote.textContent = `Equipo seleccionado: ${money(gearTotal)}. Incluido en tu selección.`; }
nativeId.value = first?.id || '';
setText('[data-unit-price],[data-single-total],[data-compare-single]', money(firstPrice));
setText('[data-pair-total],[data-compare-pair]', money(pairTotal));
setText('[data-pair-regular]', money(regularTotal));
setText('[data-second-pair-price]', money(Math.round(secondPrice * 0.6)));
setText('[data-pair-saving],[data-compare-saving]', money(regularTotal - pairTotal));
const compare = root.querySelector('[data-unit-compare]');
compare.hidden = !(first?.compare_at_price > firstPrice);
compare.textContent = first?.compare_at_price ? money(first.compare_at_price) : '';
buttons.forEach((button) => {
button.textContent = available || alreadyAdded ? (blackHawkLanguage(root) === 'pt' ? 'LEVE AGORA E GANHE UM BRINDE' : 'LLÉVALO AHORA Y RECIBE UN REGALO GRATIS') : 'NO DISPONIBLE';
button.disabled = isBusy || (!alreadyAdded && !available);
});
clothingPickers.forEach((picker) => picker.refresh());
if (changedPiece === pieces[0] && first) {
showVariantImage(first);
const url = new URL(location.href);
url.searchParams.set('variant', first.id);
history.replaceState({}, '', url);
}
if (changedPiece === pieces[1] && second) showVariantImage(second, false);
};
pieces.forEach((piece) => {
piece.querySelectorAll('[data-option-index]').forEach((select) => {
const index = Number(select.dataset.optionIndex);
if (initial.options[index] !== undefined) select.value = String(initial.options[index]);
select.addEventListener('change', () => {
status.textContent = '';
update(piece);
returnToVariantImage();
});
});
const selects = Array.from(piece.querySelectorAll('[data-option-index]'));
const picker = phantomCreateClothingPicker({
host: piece.querySelector('[data-clothing-controls]'), variants,
productId: root.dataset.productId, language: blackHawkLanguage(root),
getOptions: () => selects.map((select) => select.value), isBusy: () => isBusy,
onSizeGuide: sizeGuideTemplate ? openSizeGuide : null, sizeGuideId: `${piece.querySelector('[data-clothing-controls]').id}-inline-guide`,
setOptions: (options) => { selects.forEach((select, index) => { select.value = options[index]; }); status.textContent = ''; update(piece); returnToVariantImage(); },
});
if (picker) {
clothingPickers.push(picker);
selects.forEach((select) => { select.hidden = true; });
piece.querySelectorAll('[data-native-option-label]').forEach((label) => { label.hidden = true; });
const guideFallback = root.querySelector('[data-size-guide-fallback]');
if (sizeGuideTemplate && guideFallback) guideFallback.hidden = true;
}
});
packInputs.forEach((input) => input.addEventListener('change', () => { status.textContent = ''; update(); }));
extras.forEach((extra) => {
if (extra.kind === 'addon' && blackHawkChoiceAxes(extra.variants)) {
const host = document.createElement('div');
host.id = `${extra.select.id}-separate-options`; host.className = 'bh-addon-options';
extra.select.before(host);
extra.picker = blackHawkCreateCompactChoices({
host, variants: extra.variants, preview: false,
productId: extra.node.dataset.choiceProductId, language: blackHawkLanguage(root),
getOptions: () => extraVariant(extra)?.options || extra.options || extra.variants[0].options,
isBusy: () => isBusy,
setOptions: (options) => {
extra.options = options;
const exact = extra.variants.find((variant) => variant.options.every((value, index) => String(value) === String(options[index])));
extra.select.value = exact ? String(exact.id) : '';
status.textContent = ''; update();
},
});
if (extra.picker) extra.select.hidden = true;
}
[extra.checkbox, extra.select].forEach((control) => control.addEventListener('change', () => { status.textContent = ''; update(); }));
extra.toggle?.addEventListener('click', () => {
if (isBusy || (!extraVariant(extra)?.available && !extra.checkbox.checked)) return;
extra.checkbox.checked = !extra.checkbox.checked;
status.textContent = ''; update();
});
});
root.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
root.querySelectorAll('[data-dialog-open]').forEach((button) => button.addEventListener('click', () => root.querySelector(`#${CSS.escape(button.dataset.dialogOpen)}`)?.showModal()));
root.querySelectorAll('[data-dialog-close]').forEach((button) => button.addEventListener('click', () => button.closest('dialog').close()));
root.querySelectorAll('dialog').forEach((dialog) => dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); }));
const cartRequest = async (path, options) => {
const response = await fetch(routeRoot + path, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(options?.headers || {}) }, ...options });
const body = await response.json();
if (!response.ok) {
const error = new Error(typeof body.description === 'string' ? body.description : 'Tu selección could not be added. Please review availability and try again.');
error.httpStatus = response.status;
throw error;
}
return body;
};
const cartUnchanged = (before, after) => {
const lines = (cart) => JSON.stringify((cart.items || []).map((item) => [String(item.key || item.variant_id || item.id), Number(item.quantity)]).sort((a, b) => a[0].localeCompare(b[0])));
return Number(before.item_count) === Number(after.item_count) && Number(before.total_price) === Number(after.total_price) && lines(before) === lines(after);
};
const offerDialog = root.querySelector('[data-bh-second-offer]');
let specialPair = false;
let offerSource = 'page';
let offerEntryReason = 'price';
let offerTiming = null;
let offerChecking = false;
let offerBusy = false;
let offerOptions = [...initial.options];
let offerFirstPrice = initial.price;
let offerReturnFocus = null;
const offerCode = 'BLACKHAWK-PAIR50';
const offerNotice = root.querySelector('[data-bh-special-notice]');
const offerStatus = offerDialog?.querySelector('[data-bh-offer-status]');
const offerAccept = offerDialog?.querySelector('[data-bh-offer-accept]');
const allPants = (cart) => (cart.items || []).filter((item) => String(item.product_id) === root.dataset.productId);
const paidPants = (cart) => allPants(cart).filter((item) => !item.selling_plan_allocation && item.properties?._EliteGift !== '1' && item.properties?._EliteAddon !== '1' && !item.properties?._EliteUpgrade && !item.properties?._EliteNativePair);
const offerVariant = () => variants.find((variant) => variant.options.every((value, index) => String(value) === String(offerOptions[index])));
const offerCodes = (cart) => (cart.discount_codes || []).map((entry) => entry.code);
const applyOfferCodes = async (codes) => { if (window.EliteCartPromotions?.applyCodes) await window.EliteCartPromotions.applyCodes(codes); else { await cartRequest('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }); if (codes.length) await cartRequest('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: [...new Set(codes)].join(',') }) }); } if (codes.some((code) => code.toUpperCase() === offerCode)) { const response = await fetch(routeRoot + 'discount/' + encodeURIComponent(offerCode) + '?redirect=' + encodeURIComponent(root.dataset.cartUrl), { credentials: 'same-origin', cache: 'no-store' }); if (!response.ok) throw new Error('Your offer could not be applied.'); } return cartRequest('cart.js'); };
const refreshOffer = () => {
const second = offerVariant();
const price = Math.round((second?.price || initial.price) * 0.5);
offerDialog.querySelector('[data-bh-offer-price]').textContent = money(price);
offerDialog.querySelector('[data-bh-offer-regular]').textContent = money(second?.price || initial.price);
offerDialog.querySelector('[data-bh-offer-total]').textContent = `Dos pantalones: ${money(offerFirstPrice + price)} . Elige tu clip gratis en el carrito.`;
offerAccept.disabled = offerBusy || !second?.available;
const image = offerDialog.querySelector('.elite-extra-image img');
if (second?.featured_image?.src) { image.src = second.featured_image.src; image.removeAttribute('srcset'); }
offerPicker?.refresh();
};
const closeOffer = () => {
if (offerBusy || !offerDialog?.open) return;
offerTiming?.suppressCart();
offerDialog.close();
if (offerSource === 'cart' && offerEntryReason === 'cart') openCart();
else offerReturnFocus?.focus({ preventScroll: true });
};
let offerPicker = null;
if (offerDialog) {
offerPicker = phantomCreateClothingPicker({
host: offerDialog.querySelector('[data-bh-offer-choices]'), variants,
productId: root.dataset.productId, language: blackHawkLanguage(root),
getOptions: () => offerOptions, isBusy: () => offerBusy,
onSizeGuide: sizeGuideTemplate ? openSizeGuide : null,
setOptions: (options) => { offerOptions = options; refreshOffer(); },
});
offerDialog.querySelectorAll('[data-bh-offer-close]').forEach((button) => button.addEventListener('click', closeOffer));
offerDialog.addEventListener('cancel', (event) => { event.preventDefault(); event.stopPropagation(); closeOffer(); });
offerDialog.addEventListener('click', (event) => {
event.stopPropagation();
if (event.target !== offerDialog) return;
const bounds = offerDialog.getBoundingClientRect();
if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeOffer();
});
['pointerdown', 'mousedown', 'touchstart', 'keydown', 'keyup', 'focusin'].forEach((name) => offerDialog.addEventListener(name, (event) => event.stopPropagation()));
offerAccept.addEventListener('click', async () => {
const second = offerVariant();
if (offerBusy || isBusy || !second?.available || selectedPack() === 2 || currency !== 'USD' || document.hidden || window.EliteCartPromotions?.busy || window.__eliteTitaniumUpgradeBusy) return;
if (offerSource !== 'cart') {
specialPair = true;
packInputs.forEach((input) => { input.checked = false; });
pieces[1].querySelectorAll('[data-option-index]').forEach((select) => { select.value = second.options[Number(select.dataset.optionIndex)]; });
offerDialog.close(); update(); form.requestSubmit(); return;
}
offerBusy = true; refreshOffer(); offerStatus.hidden = false; offerStatus.textContent = 'Adding your second pair…';
let before = null, attempted = false;
const beforeVariantQuantity = (cart) => (cart.items || []).filter((item) => String(item.variant_id || item.id) === String(second.id) && !Object.keys(item.properties || {}).length).reduce((sum, item) => sum + Number(item.quantity), 0);
try {
before = await cartRequest('cart.js');
const pants = paidPants(before);
if (before.currency !== 'USD' || pants.reduce((sum, item) => sum + Number(item.quantity), 0) !== 1 || allPants(before).reduce((sum, item) => sum + Number(item.quantity), 0) !== 1) throw new Error('Your cart has changed. Revisa tu carrito before choosing this offer.');
attempted = true;
await cartRequest('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: second.id, quantity: 1 }] }) });
const after = await applyOfferCodes([...offerCodes(before), offerCode]);
const total = Number(pants[0].original_price || pants[0].price) + Math.round(second.price * 0.5);
const pairCharge = Number(after.total_price) - (after.items || []).filter((item) => String(item.product_id) !== root.dataset.productId).reduce((sum, item) => sum + Number(item.final_line_price), 0);
const gifts = (after.items || []).filter((item) => item.properties?._phantom_gift === root.dataset.productId);
const oldOther = (before.items || []).filter((item) => String(item.product_id) !== root.dataset.productId).reduce((sum, item) => sum + item.final_line_price, 0);
const newOther = (after.items || []).filter((item) => String(item.product_id) !== root.dataset.productId).reduce((sum, item) => sum + item.final_line_price, 0);
if (pairCharge !== total || newOther !== oldOther || gifts.some((item) => item.final_line_price !== 0)) throw new Error('This offer could not be combined with your current cart discounts.');
offerTiming?.suppressCart(); offerDialog.close();
openCart();
} catch (error) {
if (attempted && before) {
try {
const cart = await cartRequest('cart.js');
const updates = {};
let excess = beforeVariantQuantity(cart) - beforeVariantQuantity(before);
if (excess !== 1) throw new Error('Cart changed during the offer');
for (const item of (cart.items || []).filter((item) => String(item.variant_id || item.id) === String(second.id) && !Object.keys(item.properties || {}).length)) {
if (!excess) break;
const remove = Math.min(excess, Number(item.quantity));
updates[item.key] = Number(item.quantity) - remove; excess -= remove;
}
if (Object.keys(updates).length) await cartRequest('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
await applyOfferCodes(offerCodes(before));
offerStatus.textContent = `${error.message} Se ha conservado tu selección original.`;
} catch { offerStatus.textContent = 'No pudimos confirmar la actualización. Revisa tu carrito antes de añadir otro pantalón.'; offerAccept.hidden = true; }
} else offerStatus.textContent = error.message;
} finally { offerBusy = false; refreshOffer(); }
});
}
const offerBlocked = (reason) => !offerDialog || !twoPairOfferReady || currency !== 'USD' || root.isConnected === false || specialPair || selectedPack() === 2 || isBusy || offerBusy || document.hidden || window.EliteCartPromotions?.busy || window.__eliteTitaniumUpgradeBusy || Boolean(document.querySelector('dialog[open], .egp-open, .modal[aria-hidden="false"]')) || (reason === 'cart' ? !offerTiming?.cartReady() : Boolean(document.querySelector('.mini-cart[aria-hidden="false"]')));
const showSecondOffer = async (reason = 'price') => {
if (offerChecking || offerBlocked(reason)) return 'blocked';
offerChecking = true;
try {
const cart = await cartRequest('cart.js');
if (offerBlocked(reason)) return 'blocked';
const pants = paidPants(cart);
const count = pants.reduce((sum, item) => sum + Number(item.quantity), 0);
const totalCount = allPants(cart).reduce((sum, item) => sum + Number(item.quantity), 0);
const applied = (cart.discount_codes || []).some((entry) => String(entry.code || '').toUpperCase() === offerCode && entry.applicable !== false);
if (cart.currency !== 'USD' || count >= 2 || totalCount !== count || (reason === 'cart' && count !== 1) || applied || !findVariant(pieces[0])?.available || !variants.some((variant) => variant.available && variant.price > 0)) return 'ineligible';
offerSource = count === 1 ? 'cart' : 'page'; offerEntryReason = reason;
offerFirstPrice = count === 1 ? Number(pants[0].original_price || pants[0].price) : (findVariant(pieces[0])?.price || initial.price);
const selectedSecond = findVariant(pieces[1]);
offerOptions = [...(selectedSecond?.available ? selectedSecond : variants.find((variant) => variant.available)).options];
offerReturnFocus = document.activeElement;
offerStatus.hidden = true; offerAccept.hidden = false; refreshOffer();
if (offerBlocked(reason)) return 'blocked';
offerDialog.showModal();
if (!offerDialog.open) return 'blocked';
offerAccept.focus(); return 'opened';
} catch { return 'blocked'; } finally { offerChecking = false; }
};
// The normal 40% pack takes precedence over all promotional popup triggers.
packInputs.forEach((input) => input.addEventListener('change', () => {
specialPair = false;
if (offerDialog?.open && input.checked && input.value === '2') { offerTiming?.suppressCart(); offerDialog.close(); }
update();
}));
if (offerDialog) offerTiming = blackHawkCreateOfferTiming({ root, dialog: offerDialog, attempt: showSecondOffer });

form.addEventListener('submit', async (event) => {
event.preventDefault();
event.stopImmediatePropagation();
if (isBusy) return;
if (alreadyAdded) { openCart(); return; }
if (!twoPairOfferReady && selectedPack() !== 1) {
status.textContent = 'La oferta de dos pantalones no está disponible en este momento.';
update();
return;
}
const pack = getPack();
const first = findVariant(pieces[0]);
blackHawkStock(root, first);
const second = pack === 2 ? findVariant(pieces[1]) : null;
const selected = selectedExtras();
if (!first?.available || (pack === 2 && !second?.available) || selected.some((extra) => !extra.variant?.available)) { update(); return; }
isBusy = true;
status.textContent = 'Añadiendo tu selección…';
update();
let mutationAttempted = false;
let beforeCart = null;
try {
let before = await cartRequest('cart.js');
if (!specialPair && offerCodes(before).some((code) => code.toUpperCase() === offerCode)) before = await applyOfferCodes(offerCodes(before).filter((code) => code.toUpperCase() !== offerCode));
if (specialPair && paidPants(before).length) throw new Error('Tu carrito ya contiene pantalones Black Hawk. Revísalo antes de añadir esta oferta.');
beforeCart = before;
const items = pack === 2 && first.id === second.id ? [{ id: first.id, quantity: 2 }] : [{ id: first.id, quantity: 1 }, ...(second ? [{ id: second.id, quantity: 1 }] : [])];
const gift = selected.find((extra) => extra.kind === 'gift');
const existingGifts = (before.items || []).filter((item) => item.properties?._phantom_gift === String(root.dataset.productId));
if (gift && existingGifts.some((item) => String(item.variant_id || item.id) !== String(gift.variant.id))) {
const error = new Error('Your cart already contains this gift in another option. Revisa tu carrito to change the gift option.');
error.reviewCart = true;
throw error;
}
const addGift = Boolean(gift && existingGifts.length === 0);
selected.filter((extra) => extra.kind === 'addon').forEach((extra) => items.push({ id: extra.variant.id, quantity: 1 }));
if (addGift) items.push({ id: gift.variant.id, quantity: 1, properties: { _phantom_gift: String(root.dataset.productId) } });
const expected = first.price + (second ? Math.round(second.price * (specialPair ? 0.5 : 0.6)) : 0) + selected.filter((extra) => extra.kind === 'addon').reduce((sum, extra) => sum + extra.variant.price, 0);
const expectedQuantity = pack + selected.filter((extra) => extra.kind === 'addon').length + (addGift ? 1 : 0);
mutationAttempted = true;
await cartRequest('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
alreadyAdded = true;
const after = specialPair ? await applyOfferCodes([...offerCodes(before), offerCode]) : await cartRequest('cart.js');
const charged = Number(after.total_price) - Number(before.total_price);
const quantityAdded = Number(after.item_count) - Number(before.item_count);
const giftLines = gift ? (after.items || []).filter((item) => item.properties?._phantom_gift === String(root.dataset.productId) && String(item.variant_id || item.id) === String(gift.variant.id)) : [];
const giftConfirmed = !gift || (giftLines.reduce((sum, item) => sum + Number(item.quantity), 0) === 1 && giftLines.every((item) => Number(item.final_line_price) === 0));
if (quantityAdded !== expectedQuantity || charged !== expected || !giftConfirmed) {
status.textContent = `Tu selección está en el carrito. El precio o el descuento del regalo no coincide con el total mostrado de ${money(expected)}. Revisa el carrito y los descuentos antes de pagar.`;
reviewLink.hidden = false;
return;
}
openCart();
if (pack === 1) offerTiming?.confirmAdd();
} catch (error) {
let confirmedRejected = false;
if (mutationAttempted && !alreadyAdded && error.httpStatus && beforeCart) {
try { confirmedRejected = cartUnchanged(beforeCart, await cartRequest('cart.js')); } catch {}
}
if (mutationAttempted && !confirmedRejected) {
alreadyAdded = true;
status.textContent = 'No pudimos confirmar la actualización. Revisa tu carrito antes de volver a añadir estos pantalones.';
reviewLink.hidden = false;
} else {
status.textContent = error.message || 'No se pudo añadir tu selección. Inténtalo de nuevo.';
if (error.reviewCart) reviewLink.hidden = false;
}
} finally {
isBusy = false;
update();
}
}, true);
const bundleRadio = root.querySelector('[data-bundle-radio]');
if (bundleRadio) bundleRadio.disabled = !twoPairOfferReady;
nativeId.disabled = false;
root.dataset.ready = 'true';
update();
if (new URL(location.href).searchParams.has('variant')) showVariantImage(initial);
};
document.querySelectorAll('[data-phantom-product]').forEach(initialize);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-phantom-product]').forEach(initialize));
})();
(() => {
const initializeGear = (root) => {
if (root.dataset.ready) return;
const form = root.querySelector('.ph-gear-form');
const select = root.querySelector('[data-gear-variant]');
if (!form || !select) return;
const variants = phantomAllowedVariants(root.dataset.productId, JSON.parse(root.dataset.variants || '[]'));
phantomSelectLabels(select, root.dataset.productId);
if (!variants.length) return;
if (!variants.some((variant) => String(variant.id) === select.value)) select.value = String((variants.find((variant) => variant.available) || variants[0]).id);
const copy = JSON.parse(root.querySelector('[data-gear-content]')?.textContent || '{}')[root.dataset.handle];
const buttons = Array.from(root.querySelectorAll('[data-gear-buy]'));
const status = root.querySelector('[data-gear-status]');
const review = root.querySelector('[data-gear-review]');
const currency = root.dataset.currency || 'USD';
const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
const routeRoot = (root.dataset.root || '/').replace(/\/?$/, '/');
let busy = false;
let added = false;
let clothingPicker = null;
const offerEnabled = root.dataset.offerEnabled === 'true' && currency === 'USD';
const offerPanel = root.querySelector('[data-gear-offer-panel]');
const offerChoices = Array.from(root.querySelectorAll('[data-gear-offer-choice]')).map((node) => ({
node, variants: JSON.parse(node.dataset.offerVariants || '[]'),
radio: node.querySelector('[data-gear-offer-radio]'), select: node.querySelector('[data-gear-offer-variant]'),
productId: node.dataset.offerProductId, freeCode: node.dataset.offerFreeCode, halfCode: node.dataset.offerHalfCode,
}));
const choiceVariant = (choice) => choice.variants.find((variant) => String(variant.id) === choice.select.value);
const chosenOffer = () => offerEnabled ? offerChoices.find((choice) => choice.radio.checked) : null;
const offerMode = (variant) => variant.price >= 4000 ? 'gift' : 'addon';
const offerCharge = (variant, choice) => offerMode(variant) === 'gift' ? 0 : Math.ceil(choiceVariant(choice).price / 2);
const current = () => variants.find((variant) => String(variant.id) === select.value);
const openCart = () => blackHawkOpenCart(root, current());
const openGearSizeGuide = (event) => {
const host = event.currentTarget.closest('[data-gear-clothing-controls], [data-gear-second-clothing]');
const source = root.querySelector('.ph-jacket-size-guide');
if (!host || !source) return;
let panel = host.querySelector('[data-gear-inline-guide]');
if (!panel) {
panel = document.createElement('div'); panel.className = 'ph-inline-size-guide'; panel.dataset.gearInlineGuide = '';
panel.id = `${host.id}-guide`; panel.hidden = true; panel.append(source.cloneNode(true));
host.querySelector('.ph-size-heading').after(panel);
}
blackHawkLocalize(panel, root.dataset.productId, blackHawkLanguage(root));
panel.hidden = !panel.hidden;
event.currentTarget.setAttribute('aria-controls', panel.id);
event.currentTarget.setAttribute('aria-expanded', String(!panel.hidden));
};

const gearPairReady = root.dataset.pairReady === 'true';
const packField = root.querySelector('[data-gear-pack]');
let secondField = null, secondSelect = null, secondPicker = null;
const pairCount = () => gearPairReady && packField?.querySelector('input[value="2"]:checked') ? 2 : 1;
const secondVariant = () => variants.find((variant) => String(variant.id) === secondSelect?.value);
const mainVariants = () => pairCount() === 2 ? [current(), secondVariant()] : [current()];
const mainTotal = () => (current()?.price || 0) + (pairCount() === 2 ? Math.ceil((secondVariant()?.price || 0) * 0.6) : 0);
const mainItems = (properties = {}) => mainVariants().map((variant) => ({ id: variant.id, quantity: 1, properties }));
packField?.querySelectorAll('input').forEach((radio) => radio.addEventListener('change', () => { status.textContent = ''; update(); }));
if (gearPairReady && packField) {
const firstRadio = packField.querySelector('input[value="1"]');
const pairRadio = packField.querySelector('input[value="2"]');
if (pairRadio) { pairRadio.checked = false; pairRadio.disabled = false; } if (firstRadio) firstRadio.checked = true;
secondField = document.createElement('fieldset'); secondField.className = 'ph-gear-second';
const secondLegend = document.createElement('legend'); secondLegend.textContent = 'Unidad 2';
const secondLabel = document.createElement('label'); secondLabel.textContent = 'Elige la segunda unidad'; secondLabel.htmlFor = `${select.id}-second`;
secondSelect = select.cloneNode(true); secondSelect.id = `${select.id}-second`; secondSelect.removeAttribute('name'); secondSelect.removeAttribute('data-gear-variant'); secondSelect.value = select.value;
secondField.append(secondLegend, secondLabel, secondSelect); select.parentElement.after(secondField);
secondSelect.addEventListener('change', () => { status.textContent = ''; update(); });
if (String(root.dataset.productId) === '15447369908445') {
const host = document.createElement('div'); host.id = `${select.id}-second-clothing`; host.dataset.gearSecondClothing = ''; host.className = 'ph-clothing-controls';
secondField.insertBefore(host, secondLabel);
let secondOptions = [...(secondVariant()?.options || [])];
secondPicker = phantomCreateClothingPicker({
host, variants, compactAsian: true, onSizeGuide: root.querySelector('.ph-jacket-size-guide') ? openGearSizeGuide : null,
productId: root.dataset.productId, language: blackHawkLanguage(root),
getOptions: () => secondOptions, isBusy: () => busy,
setOptions: (options) => {
secondOptions = options;
const exact = variants.find((variant) => variant.options.every((value, index) => String(value) === String(options[index])));
secondSelect.value = exact ? String(exact.id) : ''; status.textContent = ''; update();
},
});
if (secondPicker) { secondSelect.hidden = true; secondLabel.hidden = true; }
}

}

const showMedia = (id) => {
const media = Array.from(root.querySelectorAll('[data-gear-media-id]'));
if (!media.some((item) => item.dataset.gearMediaId === String(id))) return;
media.forEach((item) => {
item.hidden = item.dataset.gearMediaId !== String(id);
if (item.hidden) item.querySelectorAll('video').forEach((video) => video.pause());
});
root.querySelectorAll('[data-gear-media-target]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.gearMediaTarget === String(id))));
};
const imagePath = (src) => { try { return new URL(src, location.origin).pathname; } catch { return ''; } };
const showVariantImage = (variant) => {
if (!variant?.featured_image?.src) return;
const media = Array.from(root.querySelectorAll('[data-gear-media-id]')).find((item) => imagePath(item.dataset.imageUrl) === imagePath(variant.featured_image.src));
if (media) showMedia(media.dataset.gearMediaId);
};
const update = (changed = false) => {
const variant = current();
const available = Boolean(variant?.available && (pairCount() === 1 || secondVariant()?.available));
const selectedOffer = chosenOffer();
const offerAvailable = !selectedOffer || Boolean(choiceVariant(selectedOffer)?.available && selectedOffer.productId !== root.dataset.productId);
const total = mainTotal() + (variant && selectedOffer && offerAvailable ? offerCharge(variant, selectedOffer) : 0);
if (offerPanel) {
offerPanel.hidden = !offerEnabled || !offerChoices.length;
root.querySelector('[data-gear-offer-title]').textContent = variant && offerMode(variant) === 'gift' ? 'Elige una linterna gratis' : 'Añade una linterna con un 50% de descuento';
root.querySelector('[data-gear-offer-intro]').textContent = variant && offerMode(variant) === 'gift' ? 'Elige OnyxClip o SlimBeam. Una unidad de la oferta por pedido.' : 'Elige OnyxClip o SlimBeam a mitad de precio.';
offerChoices.forEach((choice) => {
const extra = choiceVariant(choice);
choice.radio.disabled = busy || !available || !extra?.available || !offerEnabled;
choice.select.disabled = busy || !offerEnabled;
choice.node.querySelector('[data-gear-offer-was]').textContent = money(extra?.price || 0);
choice.node.querySelector('[data-gear-offer-now]').textContent = money(variant && extra ? offerCharge(variant, choice) : 0);
choice.node.querySelector('[data-gear-offer-badge]').textContent = variant && offerMode(variant) === 'gift' ? 'Gratis' : '50% de descuento';
choice.node.querySelector('[data-gear-offer-availability]').textContent = extra?.available ? '' : 'Esta opción está agotada.';
const image = choice.node.querySelector('[data-gear-offer-image]');
if (image && extra?.featured_image?.src) { image.src = extra.featured_image.src; image.removeAttribute('srcset'); }
});
root.querySelector('[data-gear-offer-clear]').disabled = busy;
}
root.querySelector('[data-gear-price]').textContent = money(variant?.price || 0);
const compare = root.querySelector('[data-gear-compare]');
compare.hidden = !(variant?.compare_at_price > variant?.price);
compare.textContent = variant?.compare_at_price ? money(variant.compare_at_price) : '';
root.querySelector('[data-gear-availability]').textContent = available ? '' : 'Esta opción está agotada.';
const chosen = root.querySelector('[data-gear-selected]');
if (chosen) {
const axes = blackHawkChoiceAxes(variants);
const label = variant && axes ? `${phantomHumanColor(variant.options[axes.colorIndex])} / ${blackHawkSizeAlias(variant.options[axes.sizeIndex], root.dataset.productId, blackHawkLanguage(root))}` : variant?.title === 'Default Title' ? root.dataset.title : variant?.title;
chosen.textContent = variant ? `${blackHawkLanguage(root) === 'pt' ? 'Selecionado' : 'Seleccionado'}: ${label}` : '';
}
const boxImage = root.querySelector('[data-gear-box-image]');
if (boxImage && variant?.featured_image?.src) { boxImage.src = variant.featured_image.src; boxImage.removeAttribute('srcset'); }
select.disabled = busy;
if (packField) {
packField.querySelectorAll('input').forEach((input) => { input.disabled = busy; });
packField.querySelector('[data-gear-pack-price="1"]').textContent = money(variant?.price || 0);
if (gearPairReady && secondField) {
const secondPrice = secondVariant()?.price || 0;
packField.querySelector('[data-gear-pack-price="2"]').textContent = money((variant?.price || 0) + Math.ceil(secondPrice * 0.6));
packField.querySelector('[data-gear-pair-regular]').textContent = money((variant?.price || 0) + secondPrice);
packField.querySelector('[data-gear-second-price]').textContent = money(Math.ceil(secondPrice * 0.6));
secondField.hidden = pairCount() !== 2; secondSelect.disabled = busy;
}
[1, 2].forEach((count) => {
const image = packField.querySelector(`[data-gear-pack-image="${count}"]`);
const picked = count === 2 ? secondVariant() : variant;
if (image && picked?.featured_image?.src) { image.src = picked.featured_image.src; image.removeAttribute('srcset'); }
});
}
clothingPicker?.refresh(); secondPicker?.refresh();
buttons.forEach((button) => {
button.textContent = added ? 'REVISAR EL CARRITO' : available && offerAvailable ? 'LLÉVALO AHORA' : 'AGOTADO';
button.disabled = busy || (!added && (!available || !offerAvailable));
});
if (changed && variant) {
showVariantImage(variant);
const url = new URL(location.href);
url.searchParams.set('variant', variant.id);
history.replaceState({}, '', url);
}
};
if (copy) {
root.querySelector('[data-gear-headline]').textContent = copy.headline;
root.querySelector('[data-gear-intro]').textContent = copy.intro;
root.querySelector('[data-gear-box]').textContent = copy.box;
root.querySelectorAll('[data-gear-card]').forEach((card) => {
const content = copy.cards[Number(card.dataset.gearCard)];
if (!content) { card.hidden = true; return; }
card.querySelector('[data-gear-card-title]').textContent = content[0];
card.querySelector('[data-gear-card-text]').textContent = content[1];
});
root.querySelectorAll('[data-gear-benefit-label]').forEach((node) => { node.textContent = copy.benefit_captions[Number(node.dataset.gearBenefitLabel)]; });
root.querySelectorAll('[data-gear-benefit]').forEach((dialog) => {
const content = copy.benefits[Number(dialog.dataset.gearBenefit)];
dialog.querySelector('[data-gear-benefit-title]').textContent = content[0];
dialog.querySelector('[data-gear-benefit-text]').textContent = content[1];
});
const faq = root.querySelector('[data-gear-faq]');
copy.faqs.forEach(([question, answer]) => {
const details = document.createElement('details');
const summary = document.createElement('summary');
const paragraph = document.createElement('p');
summary.textContent = question;
paragraph.textContent = answer;
details.append(summary, paragraph);
faq.append(details);
});
root.querySelectorAll('[data-gear-copy-block]').forEach((block) => { block.hidden = false; });
}
root.querySelectorAll('[data-gear-media-target]').forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.gearMediaTarget)));
root.querySelectorAll('[data-gear-dialog-open]').forEach((button) => {
button.disabled = !copy;
button.addEventListener('click', () => root.querySelector(`#${CSS.escape(button.dataset.gearDialogOpen)}`)?.showModal());
});
root.querySelectorAll('[data-gear-dialog-close]').forEach((button) => button.addEventListener('click', () => button.closest('dialog').close()));
root.querySelectorAll('dialog').forEach((dialog) => dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); }));
blackHawkLocalize(root, root.dataset.productId, blackHawkLanguage(root));
let clothingOptions = [...(current()?.options || [])];
clothingPicker = phantomCreateClothingPicker({
host: root.querySelector('[data-gear-clothing-controls]'), variants, compactAsian: true, onSizeGuide: root.querySelector('.ph-jacket-size-guide') ? openGearSizeGuide : null,
productId: root.dataset.productId, language: blackHawkLanguage(root),
getOptions: () => clothingOptions, isBusy: () => busy,
setOptions: (options) => {
clothingOptions = options;
const exact = variants.find((variant) => variant.options.every((value, index) => String(value) === String(options[index])));
select.value = exact ? String(exact.id) : '';
status.textContent = ''; update(true);
},
});
if (clothingPicker) {
const nativeOptions = root.querySelector('[data-gear-native-options]');
if (nativeOptions) nativeOptions.hidden = true;
}
select.addEventListener('change', () => { clothingOptions = [...(current()?.options || [])]; status.textContent = ''; update(true); });
offerChoices.forEach((choice) => {
choice.radio.addEventListener('change', () => {
offerChoices.forEach((other) => { if (other !== choice) other.radio.checked = false; });
status.textContent = ''; update();
});
choice.select.addEventListener('change', () => { status.textContent = ''; update(); });
});
root.querySelector('[data-gear-offer-clear]')?.addEventListener('click', () => {
offerChoices.forEach((choice) => { choice.radio.checked = false; });
status.textContent = ''; update();
});
const request = async (path, options) => {
const response = await fetch(routeRoot + path, { credentials: 'same-origin', ...options, headers: { Accept: 'application/json', ...(options?.headers || {}) } });
const body = await response.json();
if (!response.ok) {
const error = new Error(typeof body.description === 'string' ? body.description : 'Tu selección could not be added. Please review availability and try again.');
error.httpStatus = response.status;
throw error;
}
return body;
};
const unchanged = (before, after) => {
const lines = (cart) => JSON.stringify((cart.items || []).map((item) => [String(item.key || item.variant_id || item.id), Number(item.quantity)]).sort((a, b) => a[0].localeCompare(b[0])));
return Number(before.item_count) === Number(after.item_count) && Number(before.total_price) === Number(after.total_price) && lines(before) === lines(after);
};
const ownedOffer = (item) => item.properties?._EliteGift === '1' || item.properties?._EliteAddon === '1';
const itemSignature = (item) => JSON.stringify([
String(item.variant_id || item.id),
Object.entries(item.properties || {}).sort(([first], [second]) => first.localeCompare(second)),
item.selling_plan_allocation?.selling_plan?.id || null,
]);
const groupedLines = (items) => {
const groups = new Map();
items.forEach((item) => {
const key = itemSignature(item), saved = groups.get(key) || [0, 0];
groups.set(key, [saved[0] + Number(item.quantity), saved[1] + Number(item.final_line_price)]);
});
return JSON.stringify(Array.from(groups).sort(([first], [second]) => first.localeCompare(second)));
};
const codesFrom = (cart) => (cart.discount_codes || []).map((entry) => entry.code);
const normalizedCodes = (cart) => JSON.stringify(codesFrom(cart).map((code) => code.toUpperCase()).sort());
const rollbackOffer = async (api, transaction, before) => {
let cart = await api.readCart();
const updates = {};
(cart.items || []).forEach((item) => { if (item.properties?._EliteBundle === transaction) updates[item.key] = 0; });
if (Object.keys(updates).length) cart = await request('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
const restore = [];
for (const saved of (before.items || []).filter(ownedOffer)) {
const quantity = (cart.items || []).filter((item) => itemSignature(item) === itemSignature(saved)).reduce((sum, item) => sum + Number(item.quantity), 0);
if (quantity < Number(saved.quantity)) restore.push({ id: saved.variant_id || saved.id, quantity: Number(saved.quantity) - quantity, properties: saved.properties || {} });
}
if (restore.length) await request('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: restore }) });
cart = await api.applyCodes(codesFrom(before));
return Number(cart.item_count) === Number(before.item_count) && Number(cart.total_price) === Number(before.total_price) && normalizedCodes(cart) === normalizedCodes(before) && groupedLines(cart.items || []) === groupedLines(before.items || []);
};
const purchaseOffer = async (variant, choice) => {
const api = window.EliteCartPromotions;
if (!api?.readCart || !api?.applyCodes || !api?.cleanLegacy) {
status.textContent = 'La oferta seleccionada no está disponible. Continúa sin el extra o vuelve a cargar la página.';
return;
}
if (api.busy || window.__eliteTitaniumUpgradeBusy) { status.textContent = 'Hay otra actualización en curso. Inténtalo de nuevo.'; return; }
const extra = choiceVariant(choice), mode = offerMode(variant);
const code = mode === 'gift' ? choice.freeCode : choice.halfCode;
const allowedCodes = ['ELITEGIFT-ONYXCLIP', 'ELITEGIFT-SLIMBEAM', 'ELITEADDON50-ONYXCLIP', 'ELITEADDON50-SLIMBEAM'];
if (!offerEnabled || !extra?.available || choice.productId === root.dataset.productId || !allowedCodes.includes(code)) { status.textContent = 'Elige un extra disponible de otro producto.'; return; }
const expected = offerCharge(variant, choice);
const transaction = 'phantom-gear-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);
let before = null, attempted = false;
busy = true; window.__eliteTitaniumUpgradeBusy = true;
status.textContent = 'Añadiendo tu selección…'; update();
try {
await api.cleanLegacy();
before = await api.readCart();
const updates = {};
(before.items || []).forEach((item) => { if (ownedOffer(item)) updates[item.key] = 0; });
if (Object.keys(updates).length) {
attempted = true;
await request('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
}
const properties = { _EliteBundle: transaction };
if (mode === 'gift') properties._EliteGift = '1';
else { properties._EliteAddon = '1'; properties._EliteAddonCode = code; }
attempted = true;
await request('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [
...mainItems({ _EliteBundle: transaction }),
{ id: extra.id, quantity: 1, properties },
] }) });
const desired = codesFrom(before).filter((saved) => {
const upper = saved.toUpperCase();
return upper !== 'TITANIUM15' && upper !== 'TITANIUM10' && upper !== 'ELITE-TITANIUM-EXTRA50' && !upper.startsWith('ELITEGIFT-') && !upper.startsWith('ELITEADDON50-');
});
const cart = await api.applyCodes([...desired, code]);
const validCode = (cart.discount_codes || []).some((entry) => entry.code.toUpperCase() === code && entry.applicable === true);
const newLines = (cart.items || []).filter((item) => item.properties?._EliteBundle === transaction);
const main = newLines.filter((item) => !ownedOffer(item));
const mainQuantity = main.reduce((sum, item) => sum + Number(item.quantity), 0);
const mainPrice = main.reduce((sum, item) => sum + Number(item.final_line_price), 0);
const offer = newLines.find((item) => ownedOffer(item) && String(item.variant_id || item.id) === String(extra.id));
const oldRows = (before.items || []).filter((item) => !ownedOffer(item));
const preservedRows = (cart.items || []).filter((item) => !ownedOffer(item) && item.properties?._EliteBundle !== transaction);
const removedPrice = (before.items || []).filter(ownedOffer).reduce((sum, item) => sum + Number(item.final_line_price), 0);
const correctTotal = Number(cart.total_price) === Number(before.total_price) - removedPrice + mainTotal() + expected;
const singleOffer = (cart.items || []).filter(ownedOffer).reduce((sum, item) => sum + Number(item.quantity), 0) === 1;
if (!validCode || mainQuantity !== pairCount() || mainPrice !== mainTotal() || !offer || Number(offer.quantity) !== 1 || Number(offer.final_line_price) !== expected || !singleOffer || !correctTotal || groupedLines(oldRows) !== groupedLines(preservedRows)) {
console.warn('[Elite gear offer verification]', JSON.stringify({ codeApplicable: validCode, mainQuantity, expectedQuantity: pairCount(), mainPrice, expectedMainPrice: mainTotal(), giftPrice: offer?.final_line_price, expectedGiftPrice: expected, actualCartTotal: cart.total_price, correctTotal, singleOffer, oldItemsPreserved: groupedLines(oldRows) === groupedLines(preservedRows) }));
throw new Error('No se pudo aplicar la oferta. Inténtalo de nuevo o continúa sin ella.');
}
status.textContent = ''; openCart();
} catch (error) {
let restored = !attempted;
if (attempted && before) { try { restored = await rollbackOffer(api, transaction, before); } catch {} }
if (!restored) {
added = false; review.hidden = false;
status.textContent = 'No se pudo confirmar la oferta. Revisa tu carrito antes de volver a añadirla.';
} else {
added = false;
status.textContent = (error.message || 'No se pudo aplicar la oferta seleccionada.') + (attempted ? ' Se ha restaurado tu carrito.' : '');
}
} finally {
busy = false; window.__eliteTitaniumUpgradeBusy = false; update();
}
};
form.addEventListener('submit', async (event) => {
event.preventDefault();
event.stopImmediatePropagation();
if (busy) return;

const variant = current();
if (mainVariants().some((item) => !item?.available)) { update(); return; }
const selectedOffer = chosenOffer();
if (selectedOffer) { await purchaseOffer(variant, selectedOffer); return; }
busy = true;
status.textContent = 'Añadiendo tu selección…';
update();
let attempted = false;
let before = null;
try {
before = await request('cart.js');
attempted = true;
await request('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: mainItems() }) });
status.textContent = '';
openCart();
} catch (error) {
let rejected = false;
if (attempted && !added && error.httpStatus && before) {
try { rejected = unchanged(before, await request('cart.js')); } catch {}
}
if (attempted && !rejected) {
added = false;
status.textContent = 'No pudimos confirmar la actualización. Revisa el carrito antes de añadir de nuevo este producto.';
review.hidden = false;
} else {
status.textContent = error.message || 'No se pudo añadir tu selección. Inténtalo de nuevo.';
}
} finally {
busy = false;
update();
}
}, true);
root.dataset.ready = 'true';
update();
if (new URL(location.href).searchParams.has('variant') || String(root.dataset.productId) === '15447369875677') showVariantImage(current());
};
document.querySelectorAll('[data-phantom-gear-product]').forEach(initializeGear);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-phantom-gear-product]').forEach(initializeGear));
})();

  } catch(e) { console.error(e); }
})();
})();
